













import { ContrastColor } from "@/data/enums/ui";
import { Contexts } from "@/models/contexts";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    "client-footer": () => import("@/skeleton/client/clientFooter.vue"),
    "content-pane": () => import("./contentPane.vue")
  }
})
export default class LoggedOutAdmin extends Vue {
  public readonly ContrastColor = ContrastColor;
  // Life-cycle methods
  private created() {
    window.addEventListener("storage", this.onLocalStorageChange);
  }
  private beforeDestroy() {
    window.removeEventListener("storage", this.onLocalStorageChange);
  }
  public mounted() {
    this.$emit("mounted");
  }
  // Methods
  private async onLocalStorageChange({ key, newValue, oldValue }) {
    if (!oldValue && newValue) {
      if (key === `${Contexts.ADMIN}/auth/token/access_token`)
        window.location.reload();
    }
  }
}
